module.exports = __webpack_public_path__ + "img/box4-active0.74f0d747.png";